import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { STRINGS } from '../../../constants';
import { FormatterHelpers } from '../../../helpers';

const ParcelDetails = ({ parcel = {}, networkDesc, showMoreDetails }) => {
  const { _weight, _height, _width, _length, _quantity, _value } = parcel;
  const isDimensionsAvailable = !!(_height && _length && _width && _value);
  const dimensionsDetails =
    isDimensionsAvailable &&
    STRINGS.DIMENSIONS_$(_height, _width, _length, _value);
  const parcelQuantity = _quantity && `${_quantity} x`;
  const parcelWeight = _weight && `${_weight} kg ${STRINGS.PARCEL}`;

  const parcelQuantityWeightString = FormatterHelpers.joinStringsWith(
    [parcelQuantity, parcelWeight],
    ' '
  );

  const parcelWeightDescDimensionsString = FormatterHelpers.joinStringsWith(
    [`${_weight}KG ${STRINGS.PARCEL}`, networkDesc, dimensionsDetails],
    ' | '
  );

  return (
    <Box sx={{ mt: 1, pr: 1 }}>
      {showMoreDetails ? (
        <>
          <Typography variant='body2' sx={{ wordBreak: 'break-word' }}>
            {parcelQuantityWeightString}
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            {dimensionsDetails}
          </Typography>
        </>
      ) : (
        <Typography variant='body2' color='text.secondary'>
          {FormatterHelpers.joinStringsWith(
            [parcelQuantity, parcelWeightDescDimensionsString],
            ' '
          )}
        </Typography>
      )}
    </Box>
  );
};

const ParcelsPriceDetails = ({
  receiverContactName,
  parcels,
  networkDesc,
  showMoreDetails,
  price,
}) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }}
  >
    <Box>
      {receiverContactName && (
        <Box>
          <Typography variant='body2' sx={{ mb: 1, wordBreak: 'break-word' }}>
            {receiverContactName}
          </Typography>
        </Box>
      )}

      {parcels?.length &&
        parcels.map(parcel => (
          <ParcelDetails
            key={parcel._parcelId}
            parcel={parcel}
            networkDesc={networkDesc}
            showMoreDetails={showMoreDetails}
          />
        ))}
    </Box>
    <Typography variant='body2'>{price}</Typography>
  </Box>
);

ParcelsPriceDetails.propTypes = {
  receiverContactName: PropTypes.string,
  parcels: PropTypes.arrayOf(PropTypes.object),
  networkDesc: PropTypes.string,
  showMoreDetails: PropTypes.bool,
  price: PropTypes.object,
};

export default ParcelsPriceDetails;
